<template>
    <div>
    <el-dialog
      title="Replace Card"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      :before-close="handleClose"
      top="5vh"
    >
      <el-form
        :model="replaceForm"
        ref="replaceForm"
        label-width="150px"
        size="small"
        :rules="replaceFormRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >

        <el-form-item label="Replace By" prop="replace_by">
          <el-input v-model="replaceForm.replace_by" placeholder="Replace by Card ID"></el-input>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input type="textarea" v-model="replaceForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">Cancel</el-button>
        <el-button
          type="primary"
          :loading="submiting"
          @click="submitReplace()"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cardReplace } from "@/api/card";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username() {
      return this.$store.state.user.fullname;
    },
  },
  data() {
    return {
      dialogShow: false,
      submiting: false,
      replaceForm: this.model(),
      replaceFormRule: {
        replace_by: [{required: true, message: "Please enter Card ID", trigger: "blur"}],
        remark: [{required: true, message: "Please enter Remark", trigger: "blur"}],
      },
    };
  },
  methods: {
    model() {
      return {
        user: this.username,
        status: "active",
        new_card_id: "",
        replace_by: "",
        remark: "",
      };
    },
    openDialog(cardID) {
      this.replaceForm = this.model();
      this.replaceForm.new_card_id = cardID;
      this.dialogShow = true
    },
    replaceCard(){
      this.submiting = true;
      cardReplace(this.replaceForm.new_card_id, this.replaceForm).then(({result})=>{
        if(result){
          this.dialogShow = false;
          this.$notify({
            title: "Success",
            message: `Replace card successfully`,
            type: "success",
            duration: 2000,
          });
          this.$emit('submited')
        }
      })
    },
    submitReplace() {
      this.$refs.replaceForm.validate((valid) => {
        if (valid) {
          this.replaceCard()
        }else{
          console.log("error submit!!");
          return false;
        }
       });
    },
    handleClose() {
      this.dialogShow = false;
    },
  },
};
</script>

<style>
</style>